var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 69 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CURRENT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.615676153
  }, /*#__PURE__*/React.createElement("g", {
    id: "canvas-resource",
    transform: "translate(-961.000000, -709.000000)",
    fill: "#010002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(282.000000, 434.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(625.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image-add-button",
    transform: "translate(54.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.375,8.57142857 L51.75,8.57142857 L43.125,0 L25.8728438,0 L17.25,8.57142857 L8.625,8.57142857 C8.625,8.57142857 0,8.57142857 0,17.1428571 L0,42.8571429 C0,51.4285714 8.625,51.4285714 8.625,51.4285714 C8.625,51.4285714 20.8336875,51.4285714 33.4606875,51.4285714 C36.940875,56.595 42.8640938,59.9978571 49.59375,60 C57.9492188,59.9957143 65.0475938,54.7414286 67.783875,47.3807143 C68.9892188,45.1628571 69,42.8571429 69,42.8571429 C69,42.8571429 69,25.7142857 69,17.1428571 C69,8.57142857 60.375,8.57142857 60.375,8.57142857 Z M30.2586562,42.1285714 C25.1979375,40.3885714 21.5625,35.6271429 21.5625,30 C21.5625,22.9028571 27.349875,17.1428571 34.5,17.1428571 C38.6270625,17.1428571 42.2775937,19.0885714 44.6473125,22.0842857 C36.3285,24.2592857 30.1875,31.7614286 30.1875,40.7142857 C30.1875,41.1921429 30.2263125,41.6592857 30.2586562,42.1285714 Z M49.59375,55.4635714 C41.3978437,55.4442857 34.767375,48.855 34.7479687,40.7142857 C34.767375,32.5692857 41.3978437,25.98 49.59375,25.9607143 C57.7853437,25.98 64.4158125,32.5692857 64.4352187,40.7142857 C64.4158125,48.855 57.7853437,55.4442857 49.59375,55.4635714 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "52.2044 30 47.8 30 47.8 38.4 39 38.4 39 42.6 47.8 42.6 47.8 51 52.2044 51 52.2044 42.6 61 42.6 61 38.4 52.2044 38.4"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.a4f8ed5e5d83b8a6cd74644414e4264b.svg";
export { ForwardRef as ReactComponent };